"use client";
import Link from "next/link";
import Image from "next/image";
import StandardFlexibleShaftsImg from "@/Helper/images/new/standard_flexible_shafts.png";
import ReadyFlexWithcasingImg from "@/Helper/images/new/ready_flex_with_casing.png";
import ReadyFlexWithOutcasingImg from "@/Helper/images/new/ready_flex_without_casing.png";
import FlexibleShaftWithFittingsImg from "@/Helper/images/new/flexible_shaft_with_fittings.png";
import FlexibleShaftWithCasingFittingsImg from "@/Helper/images/new/flexible_shaft_with_casing_fittings.png";
import GearBoxesImg from "@/Helper/images/new/gear_boxes.png";



const products = [
  {
    url:"/standard-flexible-shaft",
    imgSrc: StandardFlexibleShaftsImg,
    title: "Standard Flexible Shafts",
    description: "S.S. White has found there are certain designs and applications that come up over and over again and would be better served by standard, 'off-the-shelf' solutions.",
  },
  {
    url:"/flexible-shaft-with-casing",
    imgSrc: ReadyFlexWithcasingImg,
    title: "Ready-Flex with Casing",
    description: "It is usually necessary for shaft lengths that exceed 8 inches. Also, casing is recommended when the environment is dirty, dusty, or corrosive.",
  },
  {
    url:"/flexible-shaft-without-casing",
    imgSrc:ReadyFlexWithOutcasingImg,
    title: "Ready-Flex without Casing",
    description: "These are used for short distances in short duty cycle applications. Designed for control-type applications to transfer slow motion from one point to another.",
  },

  {
    url:"/gear-boxes",
    imgSrc: GearBoxesImg,
    title: "Gear Boxes",
    description: "Used for short distances in short duty cycle applications. Designed for control-type applications to transfer slow motion from one point to another.",
  },
];

const HomeProductsSection = () => {
  return (
    <div className="wrk_plsection">
      <div className="container">
        <div className="wrk_plleftcolums_row">
          {/* Left Section */}
          <div className="offworkleft wrk_plleftcolums">
            <div className="wrk_plleft">
              <p className="wrk_plheading">Flexible Shaft Solutions for Complex Power Transmission Challenges</p>
              <p className="wrk_plcontent">
               For over 100 years, S.S. White has been offering flexible shafts as a versatile solution for power transmission needs. These shafts cater to various requirements such as component connection, compensating for lateral and angular offsets, navigating obstacles, dampening vibrations, and managing displacement. They can be used with or without casing, depending on the length and intended application.
              </p>
              <div className="viewbtn">
                <Link href="#" className="btn btn-primary">
                  View all<span className="right_arrowcontact1"></span>
                </Link>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="offworkleft wrk_plrgtcolums">
            <div className="wrk_plrgt">
              <div className="wrk_plrgtlistout">
                {products.map((product, index) => (
                  <div key={index} className="wrk_plrgtlist">
                    <div className="wrk_plrgtlistlft">
                      <Image
                        className="lazy"
                        src={product.imgSrc}
                        alt={product.title}
                        width={100}
                        height={100}
                        priority
                      />
                    </div>
                    <div className="wrk_plrgtlistrgt">
                      <p className="wrk_pllistheading">{product.title}</p>
                      <p className="wrk_pllistcontent">{product.description}</p>
                      <div className="viewbtn1">
                        <Link href={product.url} title="READ MORE" className="btn-primary">
                          READ MORE<span className="readmorebutton_arrow"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomeProductsSection;
